(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/map-of-winners/assets/javascripts/models/bigwin.js') >= 0) return;  svs.modules.push('/modules/map-of-winners/assets/javascripts/models/bigwin.js');
"use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.map_of_winners.models.BigWin = Backbone.Model.extend({
    defaults() {
      return {
        winType: undefined,
        winTypeText: undefined,
        date: undefined,
        retailer: undefined,
        isRetailer: false,
        city: undefined,
        lat: undefined,
        lng: undefined,
        gameType: undefined,
        shares: undefined,
        position: {}
      };
    },
    CONSTANTS: svs.map_of_winners.data.constants,
    initialize(attr, options) {
      if (attr) {
        this.set('winTypeText', "".concat(this.CONSTANTS.WIN_TYPE_TEXT[attr.winType], " ").concat(svs.utils.date.ShortDateAndTime(attr.date, true, false)));
      }
      if (options && options.mapDimension) {
        this.convertGeoToPercent(options.mapDimension.mapWidth, options.mapDimension.mapHeight);
      }
    },
    convertGeoToPercent(mapWidth, mapHeight) {
      const MAP_LON_LEFT = 11.098053868437546,
        MAP_LON_RIGHT = 24.188199270962514,
        MAP_LAT_BOTTOM = 55.330523792868924;
      const mapLonDelta = MAP_LON_RIGHT - MAP_LON_LEFT,
        mapLatBottomDegree = MAP_LAT_BOTTOM * Math.PI / 180;
      let x = (this.get('lng') - MAP_LON_LEFT) * (mapWidth / mapLonDelta);
      const latitude = this.get('lat') * Math.PI / 180;

      const worldMapWidth = mapWidth / mapLonDelta * 360 / (2 * Math.PI),
        mapOffsetY = worldMapWidth / 2 * Math.log((1 + Math.sin(mapLatBottomDegree)) / (1 - Math.sin(mapLatBottomDegree)));
      let y = mapHeight - (worldMapWidth / 2 * Math.log((1 + Math.sin(latitude)) / (1 - Math.sin(latitude))) - mapOffsetY);
      x = x / mapWidth * 100;
      y = y / mapHeight * 100;
      this.set('position', {
        horizontalPos: x,
        verticalPos: y
      });
    }
  });
})(Backbone, _, svs);

 })(window);